import React from "react";
import { IoIosWarning } from "react-icons/io";

// interface EditDialogProps {
//   visible: boolean;
//   loading?: boolean;
//   handleOk: () => void;
//   handleCancel: () => void;
// }

const ActionDialog = ({
  action = "",
  title = "",
  desc = "",
  visible,
  loading,
  handleOk,
  handleCancel,
}) => {
  if (!visible) return null; // don’t render if hidden

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        {/* Header */}
        <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <IoIosWarning className="text-red-500 text-2xl" /> <p>{title}</p>
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-6">{desc}</p>

        {/* Footer (Buttons) */}
        <div className="flex justify-end gap-3">
          <button
            onClick={handleCancel}
            className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleOk}
            disabled={loading}
            className={`px-4 py-2 rounded-md text-white transition ${
              loading
                ? "bg-blue-300 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {loading ? "Processing..." : `${action} Offer`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionDialog;
